<div class="help-contact-form">
    <div class="help-contact-form__header">
        <eb-h2>{{ 'help.form.title' | transloco }}</eb-h2>
    </div>

    <form
        class="help-contact-form__body"
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
    >
        <div class="d-flex flex-column form__group">
            <eb-label
                class="ml-2 mb-1 form__label-required"
                color="flat-secondary"
                size="md"
                textTransform="uppercase"
                weight="bold"
            >
                {{ 'help.form.subject_label' | transloco }}
            </eb-label>
            <eb-select-text-input
                class="help-contact-form__select"
                [options]="subjectOptions()"
                [placeholder]="'help.form.subject_placeholder' | transloco"
                color="white"
                formControlName="subject"
                size="mb-1"
            />
        </div>

        @if (selectedSubjectDescription()) {
            <eb-alert
                class="help-contact-form__alert"
                type="info"
                [text]="selectedSubjectDescription()!"
            />
        }

        <div class="d-flex flex-column form__group">
            <eb-label
                class="ml-2 mb-1"
                [class.form__label-required]="isAttachmentRequired()"
                color="flat-secondary"
                size="md"
                textTransform="uppercase"
                weight="bold"
            >
                {{ 'help.form.file_label' | transloco }}
                @if (!isAttachmentRequired()) {
                    ({{ 'common.optional' | transloco }})
                }
            </eb-label>
            <eb-file-dropzone
                [files]="files()"
                [accept]="'.pdf,.csv,.jpg,.jpeg,.png,.xls,.xlsx,.ods'"
                [multiple]="true"
                (filesChange)="files.set($event)"
            />
        </div>

        <div class="d-flex flex-column form__group">
            <eb-label
                class="ml-2 mb-1 form__label-required"
                color="flat-secondary"
                size="md"
                textTransform="uppercase"
                weight="bold"
            >
                {{ 'help.form.message_label' | transloco }}
            </eb-label>
            <textarea
                class="classic-input-round-bg help-contact-form__textarea"
                [placeholder]="'help.form.message_placeholder' | transloco"
                formControlName="message"
                rows="4"
            ></textarea>
        </div>

        <div class="d-flex align-items-center justify-content-center mt-4">
            <button
                eb-button
                type="submit"
                [disabled]="form.invalid || (isAttachmentRequired() && files().length === 0)"
                [isV2]="true"
                color="primary-v2"
                size="small"
            >
                {{ 'common.send' | transloco }}
            </button>
        </div>
    </form>
</div>
